import PlusIcon from '@components/icons/PlusIcon';
import IconButton from '@mui/material/IconButton';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CargoSelectionItem } from '../CargoSelectionItem';
import { SelectionCustomCargoParameters, SelectionCustomCargoType } from '../types';

// Свойства компонента
export interface CargoSelectionListProps {
  selectionCargoParamaters: SelectionCustomCargoParameters[];
  BaseData: RouteWidgetBaseParameters;
  isActionsDisabled: boolean;
  mainLanguage: string; // Текущий основной язык
  onChangeSelectionCargoParameters: (
    cargoParameters: SelectionCustomCargoParameters,
    index: number
  ) => void;
  onAddSelectionCargoParameters: () => void;
  onDeleteSelectionCargoParameters: (index: number) => void;
}

// Компонент вывода конфигурации грузов для подбора параметров груза
const CargoSelectionList: FC<CargoSelectionListProps> = (props) => {
  const {
    BaseData,
    mainLanguage,
    isActionsDisabled,
    selectionCargoParamaters,
    onAddSelectionCargoParameters,
    onChangeSelectionCargoParameters,
    onDeleteSelectionCargoParameters,
  } = props;
  const { t } = useTranslation('Actions');

  return (
    <section className="cargo-list">
      {selectionCargoParamaters.map((params, i) => {
        const type: SelectionCustomCargoType =
          params.parametersCargoCalcType === 'base'
            ? params.customCargoType
            : params.parametersCargoCalcType;
        return (
          <div key={`list-selection-params-item-${i}`} className={'cargo-item'}>
            <CargoSelectionItem
              position={i + 1}
              BaseData={BaseData}
              cargoType={type}
              selectionCargoParamaters={params}
              mainLanguage={mainLanguage}
              isDeletable={selectionCargoParamaters.length > 1}
              isActionsDisabled={isActionsDisabled}
              onChangeSelectionCargoParameters={(p) => onChangeSelectionCargoParameters(p, i)}
              onDeleteSelectionCargoParameters={() => onDeleteSelectionCargoParameters(i)}
            />
          </div>
        );
      })}
      <IconButton
        title={`+ ${t('Actions:Add')}`}
        className={'add-new-cargo'}
        disabled={isActionsDisabled}
        onClick={onAddSelectionCargoParameters}
      >
        <PlusIcon />
      </IconButton>
    </section>
  );
};

// Экспортируем компонент
export default CargoSelectionList;
